<template>
  <transition name="fade">
    <div v-if="text" class="loadingMask">
      <div class="loading">
        <div class="loadingSpinner">
          <svg class="loadingCircular" viewBox="25 25 50 50">
            <circle cx="50" cy="50" r="20" fill="none" />
          </svg>
        </div>
        <div class="loadingText">
          {{ text }}
        </div>
      </div>
      <span v-if="remark">
        {{ remark }}
      </span>
    </div>
  </transition>
</template>

<script setup>
import { ref } from 'vue';

const text = ref(''); // 文本
const remark = ref(''); // 备注

/**
 * 设置加载状态
 */
function setLoading(value, remarkValue) {
  text.value = value;
  remark.value = remarkValue || '';
}

defineExpose({ setLoading });
</script>

<style lang="less" scoped>
.loadingMask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5999;

  > span {
    position: absolute;
    bottom: 0.1rem;
    left: 0.1rem;
    color: #838080;
    font-size: 0.14rem;
    font-weight: 400;
    max-width: 80%;
    overflow: hidden;
  }
}

.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1rem;
  height: 1rem;
  border-radius: 0.08rem;
  background-color: rgba(0, 0, 0, 0.65);
  z-index: 5999;
}

.loadingSpinner {
  position: relative;
  display: inline-block;
  width: 0.42rem;
  height: 0.42rem;
  vertical-align: middle;
  animation: rotateAnimation 2s linear infinite;
  color: #ffffff;
}

.loadingCircular {
  display: block;
  width: 100%;
  height: 100%;

  circle {
    animation: circularAnimation 1.5s ease-in-out infinite;
    stroke: currentColor;
    stroke-width: 3;
    stroke-linecap: round;
  }
}

.loadingText {
  margin-top: 0.08rem;
  color: #ffffff;
  font-size: 0.14rem;
  text-align: center;
}

@keyframes rotateAnimation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes circularAnimation {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120;
  }
}

.fadeEnterActive,
.fadeLeaveActive {
  transition: opacity 0.3s;
}

.fadeEnter,
.fadeLeaveTo {
  opacity: 0;
}
</style>
